import { Flex } from '@revenuemarket/cds';
import { Alert, Typography } from 'antd';

import { css } from '~libs/emotion';

interface Props {
  status: 'FAILED' | 'WARNING';
}

const WiringAccountCheckBanner: React.FC<Props> = ({ status }) => {
  if (status === 'FAILED') {
    return (
      <Alert
        banner
        type="error"
        className={css`
          & .anticon {
            width: 16px;
          }
        `}
        style={{
          padding: '11px 16px',
        }}
        description={
          <Flex align="center" gap={8}>
            <Typography.Text>
              <b>예금주를 찾을 수 없는 계좌가 있습니다.</b> 계좌번호를 다시 확인해보세요.
            </Typography.Text>
          </Flex>
        }
      />
    );
  }

  if (status === 'WARNING') {
    return (
      <Alert
        banner
        type="warning"
        className={css`
          & .anticon {
            width: 16px;
          }
        `}
        style={{
          padding: '11px 16px',
        }}
        description={
          <Flex align="center" gap={8}>
            <Typography.Text>
              <b>거래처 사업자등록번호와 예금주가 일치하지 않는 계좌가 있습니다.</b> 계좌번호를 다시
              확인해보세요. 무시하고 진행하려면 다음 버튼을 클릭하세요.
            </Typography.Text>
          </Flex>
        }
      />
    );
  }
};

export default WiringAccountCheckBanner;
